import React from 'react';
import styles from './OfficeInfoConfirmModal.module.scss';
import { getDOParkingLabel } from 'utils/parking';

export interface OfficeLocationInfo {
  id: number;
  address: string;
  primaryContact?: string;
  parking?: string;
  avgApptTime?: string;
  radiography?: string;
  ultrasonic?: string;
  charting?: string;
  software?: string;
}

interface OfficeInfoConfirmModalProps {
  isOpen: boolean;
  location: OfficeLocationInfo | null;
  onConfirm: () => void;
  onChange: () => void;
  onClose: () => void;
}

const OfficeInfoConfirmModal: React.FC<OfficeInfoConfirmModalProps> = ({
  isOpen,
  location,
  onConfirm,
  onChange,
  onClose
}) => {
  if (!isOpen || !location) return null;

  return (
    <>
      <div className={styles.modalOverlay} onClick={onClose} />
      <div className={styles.modal} role="dialog" aria-modal="true">
        <div className={styles.modalContent}>
          <h2 className={styles.modalTitle}>Confirm your office information</h2>
          <ul className={styles.infoList}>
            {location.primaryContact && (
              <li><b>Primary Contact</b>: {location.primaryContact}</li>
            )}
            {location.parking && (
              <li><b>Parking</b>: {getDOParkingLabel(location.parking)}</li>
            )}
            {location.avgApptTime && (
              <li><b>Avg Recall</b>: {location.avgApptTime}</li>
            )}
            {location.radiography && (
              <li><b>Radiography</b>: {location.radiography}</li>
            )}
            {location.ultrasonic && (
              <li><b>Ultrasonic</b>: {location.ultrasonic}</li>
            )}
            {location.charting && (
              <li><b>Charting</b>: {location.charting}</li>
            )}
            {location.software && (
              <li><b>Software</b>: {location.software}</li>
            )}
          </ul>
          <div className={styles.modalActions}>
            <button className={styles.primaryButton} onClick={onConfirm}>Confirm</button>
            <button className={styles.secondaryButton} onClick={onChange}>Change</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfficeInfoConfirmModal;


